import "core-js/modules/es6.reflect.construct.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import dayjs from 'dayjs';
var WorkTimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(WorkTimeoutError, _Error);
  var _super = _createSuper(WorkTimeoutError);
  // we pass along both duration & date for debugging purposes
  function WorkTimeoutError(timeoutDuration, timeoutDate, request, ETag) {
    var _this;
    _classCallCheck(this, WorkTimeoutError);
    _this = _super.call(this, "The request for ".concat(ETag, " took more than ").concat(timeoutDuration, "s, past ").concat(timeoutDate, " to complete at ").concat(dayjs().toISOString()));
    _this.timeoutDuration = timeoutDuration;
    _this.timeout = timeoutDate;
    _this.request = request;
    _this.ETag = ETag;
    return _this;
  }
  return _createClass(WorkTimeoutError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export default WorkTimeoutError;